export default "__VITE_ASSET__BC62PLtC__"